import { useAppContext } from "../../../useAppContext";
import { Box, LocalizedString } from "@dbn/omnichannel-design-system-g4p";
import * as classes from "./DownloadAppButton.css";
import { foldTenant, SupportedLocales, Tenant } from "../../../globalDomain";
import { useMemo } from "react";
import AppStoreBadgeEN from "./AppStoreBadgeEN";
import AppStoreBadgeCZ from "./AppStoreBadgeCZ";
import AppStoreBadgeSK from "./AppStoreBadgeSK";
import GooglePlayBadgeEN from "./GooglePlayBadgeEN";
import GooglePlayBadgeCZ from "./GooglePlayBadgeCZ";
import GooglePlayBadgeSK from "./GooglePlayBadgeSK";

type Platform = "iOS" | "Android";

export type Props = {
  platform: Platform;
  ariaLabelMessage: LocalizedString;
};

function storeButton(
  platform: Platform,
  locale: SupportedLocales
): JSX.Element {
  if (platform === "iOS") {
    switch (locale) {
      case "en":
        return <AppStoreBadgeEN />;
      case "cs":
        return <AppStoreBadgeCZ />;
      case "sk":
        return <AppStoreBadgeSK />;
    }
  } else if (platform === "Android") {
    switch (locale) {
      case "en":
        return <GooglePlayBadgeEN />;
      case "cs":
        return <GooglePlayBadgeCZ />;
      case "sk":
        return <GooglePlayBadgeSK />;
    }

    return <></>;
  }
  return <></>;
}

function storeLink(platform: Platform, tenant: Tenant): string {
  switch (platform) {
    case "Android":
      return foldTenant(
        tenant,
        () =>
          "https://play.google.com/store/apps/details?id=hr.asseco.android.jimba.mUCI.sk",
        () =>
          "https://play.google.com/store/apps/details?id=hr.asseco.android.jimba.mUCI.cz"
      );
    case "iOS":
      return foldTenant(
        tenant,
        () => "https://apps.apple.com/sk/app/smart-banking/id441496696",
        () => "https://apps.apple.com/cz/app/smart-banking/id468057018"
      );
  }
}

export function DownloadAppButton(props: Props) {
  const {
    apiParameters: { tenant, language },
  } = useAppContext();

  const fetchStoreButton = useMemo(
    () => storeButton(props.platform, language),
    [props.platform, language]
  );

  return (
    <Box className={classes.downloadAppButton} column hAlignContent="center">
      <a
        href={storeLink(props.platform, tenant)}
        aria-label={props.ariaLabelMessage}
        target="_blank"
        rel="noopener noreferrer"
        className={classes.downloadAppButtonLink}
      >
        <Box>{fetchStoreButton}</Box>
      </a>
    </Box>
  );
}
